import React, { useState, useRef, useEffect } from "react";
import "./index.m.css";
import { SUBSCRIBE_PAGE_TEXT } from "../../../../constants";
import { CloseIcon, WarningTopIcon, DropdownCaretIcon, DocumentInfoIcon } from "./icons";
import { SpinnerLoader } from "../../../common/loader";

export const AutoModal = ({ onClose, onCancelClick }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedReason, setSelectedReason] = useState("");
  const [otherReasonText, setOtherReasonText] = useState("");
  const [showError, setShowError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const dropdownRef = useRef(null);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  // Close dropdown when clicking outside of it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    if (isDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpen]);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleSelectReason = (reason) => {
    setSelectedReason(reason);
    setIsDropdownOpen(false);
    setShowError(false);
  };

  const isOtherSelected = selectedReason === "ಇತರೆ";

  const handleCancelClick = async () => {
    if (isSubmitting) return;

    if (!selectedReason || (isOtherSelected && !otherReasonText.trim())) {
      setShowError(true);
      return;
    }

    try {
      setIsSubmitting(true);
      await Promise.resolve(onCancelClick(isOtherSelected ? otherReasonText.trim() : selectedReason));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div styleName="overlay" onClick={onClose}>
      {isSubmitting ? <SpinnerLoader /> :
        <div styleName={isDropdownOpen ? "popupContainer popupContainerOpen" : "popupContainer"} onClick={(e) => e.stopPropagation()}>
          <CloseIcon styleName="closeIcon" onClick={onClose} />

          <WarningTopIcon styleName="warningIcon" />

          <h2 styleName="title" dangerouslySetInnerHTML={{ __html: SUBSCRIBE_PAGE_TEXT.AUTO_CANCEL_TITLE }} />

          <div styleName="dropdownContainer" ref={dropdownRef}>
            <div
              styleName={["dropdownSelect", isDropdownOpen && "dropdownSelectOpen", (showError && !selectedReason) && "dropdownSelectError"].filter(Boolean).join(" ")}
              onClick={toggleDropdown}
            >
              <span styleName={selectedReason ? "dropdownLabel dropdownLabelSelected" : "dropdownLabel"}>
                {selectedReason || SUBSCRIBE_PAGE_TEXT.AUTO_CANCEL_DROPDOWN_PLACEHOLDER}
              </span>
              <DropdownCaretIcon />
            </div>

            {isDropdownOpen && (
              <div styleName="dropdownMenu">
                {SUBSCRIBE_PAGE_TEXT.AUTO_CANCEL_REASONS.map((reason, index) => (
                  <div
                    key={index}
                    styleName="dropdownItem"
                    onClick={() => handleSelectReason(reason)}
                  >
                    {reason}
                  </div>
                ))}
              </div>
            )}
          </div>

          {isOtherSelected && (
            <input
              type="text"
              styleName={["otherInput", (showError && isOtherSelected && !otherReasonText.trim()) && "otherInputError"].filter(Boolean).join(" ")}
              placeholder={SUBSCRIBE_PAGE_TEXT.AUTO_CANCEL_OTHER_PLACEHOLDER}
              value={otherReasonText}
              onChange={(e) => {
                setOtherReasonText(e.target.value);
                setShowError(false);
              }}
            />
          )}

          {showError && (
            <p styleName="alertMsg">
              {!selectedReason
                ? SUBSCRIBE_PAGE_TEXT.AUTO_CANCEL_ALERT_MSG
                : SUBSCRIBE_PAGE_TEXT.AUTO_CANCEL_OTHER_ALERT_MSG}
            </p>
          )}

          <div styleName="infoBox">
            <DocumentInfoIcon styleName="infoBoxIcon" />
            <p styleName="infoBoxText">{SUBSCRIBE_PAGE_TEXT.AUTO_CANCEL_INFO_TEXT}</p>
          </div>

          <div styleName="buttonsWrapper">
            <button styleName="buttonKeep" onClick={onClose}>
              {SUBSCRIBE_PAGE_TEXT.AUTO_CANCEL_BTN_KEEP}
            </button>
            <button
              styleName={["buttonCancel", isSubmitting && "buttonCancelDisabled"].filter(Boolean).join(" ")}
              onClick={handleCancelClick}
              disabled={isSubmitting}
            >
              {SUBSCRIBE_PAGE_TEXT.AUTO_CANCEL_BTN_CANCEL}
            </button>
          </div>

        </div>}
    </div>
  );
};
